import {AnyEvent, JOBS_ARCHIVED_EVENT, JobsArchivedEvent} from '../type';

export default function jobsArchived(payload: JobsArchivedEvent['payload']): AnyEvent {
  return {
    type: JOBS_ARCHIVED_EVENT,
    payload,
  }
}